import Welcome from "../../../welcome/screens/welcome/welcome";
import { useContext, useEffect } from "react";
import MyNexarContext from "../../../../components/my-nexar-context/my-nexar-context";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function ConnectGateway() {
  const context = useContext(MyNexarContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    if (context.userAuthenticated === true) {
      navigate("/connect");
    }
  }, [context.userAuthenticated]);

  const subtitle = (
    <span data-testid={"welcome-subtitle-login"}>
      {t("loginToManageYourAccount")}
    </span>
  );

  return <Welcome subtitle={subtitle} />;
}
